module.exports = __webpack_public_path__ + "img/31-warning.781b2e50.svg";